import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as InfoIcon } from 'assets/icons/svgs/icon-info1.svg';
import { Link } from '../Link/Link';
import './InfoPopover.scss';

export const InfoPopover = (props) => {
  const { infoLinkLabel, infoContent, extendClass = '', displayLabelOnMobile } = props;
  const [isPopoverOpen, setIsPopoverOpen] = useState(null);
  const popoverRef = useRef(null);

  useEffect(() => {
    const handler = (event) => {
      if (isPopoverOpen && popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsPopoverOpen(false);
      }
    };

    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [isPopoverOpen]);

  const handleClick = () => {
    setIsPopoverOpen((prevState) => !prevState);
  };

  const containerClasses = displayLabelOnMobile ? 'show-label' : '';
  const popoverClasses = isPopoverOpen ? 'open' : 'fade';

  return (
    <div className={`${extendClass} ${containerClasses} info-popover`} ref={popoverRef}>
      <Link
        href="#"
        onClick={handleClick}
        variant="secondary"
        startIcon={<InfoIcon />}
        noUnderline
        extendClass="info-popover__button"
      >
        <span className="info-popover__button-label">{infoLinkLabel}</span>
      </Link>

      <div
        className={`info_popover__container ${popoverClasses} top`}
        data-testid="popover-container"
      >
        <div className="arrow" />
        <div className="info-popover__content">{infoContent}</div>
      </div>
    </div>
  );
};

InfoPopover.propTypes = {
  infoLinkLabel: PropTypes.string,
  infoContent: PropTypes.string.isRequired,
  extendClass: PropTypes.string,
  displayLabelOnMobile: PropTypes.bool,
};
